import { render, staticRenderFns } from "./HolidaySettingFormModal.vue?vue&type=template&id=54589c05&scoped=true&"
import script from "./HolidaySettingFormModal.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingFormModal.vue?vue&type=script&lang=js&"
import style0 from "./HolidaySettingFormModal.vue?vue&type=style&index=0&id=54589c05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54589c05",
  null
  
)

export default component.exports